import ChargerModule from '../../../../components/chargerModule/ChargerModule';
import BordOneToneIcon from '../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import useStockOrdersModuleState, { ISelectedProductData } from '../../../../state/useStockOrdersModuleState';
import { CREAT_NEW_ORDER_STOCK_STEPS } from '../../../../types/orders';
import SelectProducts from './components/SelectProducts/SelectProducts';
import SelectWarehouse from './components/SelectWarehouse/SelectWarehouse';
import useSWRMutation from 'swr/mutation';
import { SWR_KEYS } from '../../../../constants/constants';
import { createStockOrder } from '../../../../services/stockOrders';
import { IStockOrder } from '../../../../types/stockOrders';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../utils/displayNudosStandardNotifications';
import { useHistory } from 'react-router-dom';
import './CreateNewOrderStock.scss';

const CreateNewOrderStock = () => {
  const { push } = useHistory();
  const {
    currentStep,
    selectedProvider,
    orderProvider,
    invoiceProvider,
    selectedProducts,
    selectedCountryCode,
    resetStockOrdersState
  } = useStockOrdersModuleState();

  const { trigger: createStockOrderTrigger, isMutating: isLoadingCreateStockOrder } = useSWRMutation(
    SWR_KEYS.createStockOrder,
    async (
      __,
      {
        arg
      }: {
        arg: IStockOrder;
      }
    ) => createStockOrder(arg),
    {
      onSuccess: async response => {
        if (response?.status !== 200 && response?.status !== 201) {
          displayErrorNotification({ customJSXMessage: <>Error al crear la orden</> });
        } else {
          displaySuccessNotification({
            customJSXMessage: <>Se ha creado con éxito la orden N° {response?.data?.id}</>
          });
          resetStockOrdersState();
          push('/stock/list-stock');
        }
      }
    }
  );

  const validateSelectedProducts = (products: ISelectedProductData[]) => {
    if (products?.length === 0) return false;

    return products.every(product => {
      const hasValidQuantity = product.quantity !== 0;
      const hasValidValue = product.taxCost !== 0;
      return hasValidQuantity && hasValidValue;
    });
  };

  const SelectSomeProducts = selectedProducts?.length === 0;
  const hasValidProducts = !SelectSomeProducts && validateSelectedProducts(selectedProducts);
  const isDisabled = !selectedProvider || !orderProvider || !hasValidProducts;
  const isSelectedProducts = currentStep === CREAT_NEW_ORDER_STOCK_STEPS.SELECT_PRODUCTS;

  const renderSteps: Record<number, React.ReactNode> = {
    [CREAT_NEW_ORDER_STOCK_STEPS.SELECT_WAREHOUSE]: <SelectWarehouse />,
    [CREAT_NEW_ORDER_STOCK_STEPS.SELECT_PRODUCTS]: <SelectProducts />
  };

  const headerInfo = {
    title: 'Stock propio',
    searchbarPlaceholder: '',
    subtitle: 'Compra'
  };

  const handleCreateOrder = () => {
    if (isDisabled) return;

    if (!selectedCountryCode) {
      displayErrorNotification({ customJSXMessage: <>Debes seleccionar un país</> });
      return;
    }

    const stockOrderData = {
      countryCode: selectedCountryCode,
      providerId: Number(selectedProvider?.id),
      providerName: String(selectedProvider?.name),
      providerOrderNumber: String(orderProvider),
      providerInvoiceNumber: invoiceProvider ? String(invoiceProvider) : null,
      items: selectedProducts?.map(product => ({
        sku: product.sku,
        quantity: product.quantity,
        value: product.taxCost
      }))
    };

    createStockOrderTrigger(stockOrderData as unknown as IStockOrder);
  };

  return (
    <ChargerModule infoSideBar={{ position: 'stock' }} headerInfo={headerInfo} viewSearchBar={false}>
      <div className="createNewOrderStockContent">
        {renderSteps[currentStep]}
        {isSelectedProducts && (
          <div
            className={`createNewOrderStockFloatButton ${isDisabled ? 'disabled' : 'active'}`}
            onClick={handleCreateOrder}
          >
            <BordOneToneIcon variant="plusSquare" standardSize={18} />
            <div>{isLoadingCreateStockOrder ? 'Creando orden...' : 'Crear orden'}</div>
          </div>
        )}
      </div>
    </ChargerModule>
  );
};

export default CreateNewOrderStock;
